import React from 'react';

import IconAutoSweepFlash from 'Icon/AutoSweep/IconFlash.svg';
import IconAutoSweepRupiahRounded from 'Icon/AutoSweep/IconRupiahRounded.svg';

import { MessageBox, Typography } from '@ajaibid/components';
import { formatCurrency } from '@ajaibid/utils';
import stockService from '@services/stock';

import { useStockBuySellContext } from '../../../hooks';
import { DayTradingInfoItem } from './style';

const DayTradingInfo = () => {
  const { code, formState, formKey, isBuy, isAccountDT } = useStockBuySellContext();

  const { isTradeable: isDtTradeable } = stockService.detail.dt.tradeable.useDtTradeable(code);
  const { data: dtTradelimit } = stockService.account.dt.tradelimit.useDtTradelimit({
    code,
    enabled: isDtTradeable, // Only call API when stock is DT tradeable
  });

  const total = formState[formKey.CALC_ORDER_TOTAL];
  const multiplier = Number.parseFloat(formState[formKey.INPUT_ACCOUNT_TYPE]?.multiplier);
  const remainingLoanLimit = dtTradelimit?.remaining_loan_limit;

  const calculateCashAndLoanPortion = () => {
    let totalLoan = 0;
    let cashUsed = 0;
    if (Number.isNaN(total) || Number.isNaN(multiplier) || Number.isNaN(remainingLoanLimit)) {
      return {
        cashUsed,
        totalLoan,
      };
    }

    const totalWithMultiplier = (Math.max(multiplier - 1, 1) / multiplier) * total;
    totalLoan = Math.min(totalWithMultiplier, remainingLoanLimit);
    cashUsed = total - totalLoan;
    return {
      cashUsed,
      totalLoan,
    };
  };
  const { cashUsed, totalLoan } = calculateCashAndLoanPortion();

  return isAccountDT && isBuy ? (
    <MessageBox type="info" icon={false} style={{ marginTop: 16, padding: 12 }}>
      <div className={DayTradingInfoItem}>
        <img src={IconAutoSweepRupiahRounded} alt="Rupiah" />
        <Typography size="sm" margin={0}>
          <strong>Terpakai dari Reguler:</strong> {formatCurrency(cashUsed, 'IDR')}
        </Typography>
      </div>
      <div className={DayTradingInfoItem}>
        <img src={IconAutoSweepFlash} alt="DT Multiplier" />
        <Typography size="sm" margin={0}>
          <strong>Terpakai dari Day Trading:</strong> {formatCurrency(totalLoan, 'IDR')}
        </Typography>
      </div>
    </MessageBox>
  ) : null;
};

export default DayTradingInfo;
